const AnchoredTextIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28">
            <path fill="currentColor" d="m6.5 5C5.68 5 5 5.67 5 6.5v2h1v-2c0-.27.23-.5.5-.5H11v16H9v1h5v-1h-2V6h4.5c.28 0 .5.22.5.5v2h1v-2c0-.83-.67-1.5-1.5-1.5h-10zM25 19c0 2.48-2.02 4-4.5 4S16 21.49 16 19h1c0 1.8 1.42 3 3.5 3s3.5-1.2 3.5-3m-6-2h5v1h-5m3-3.5v8h-1v-8m.5.5a1 1 0 0 1 0-3 1 1 0 0 1 0 3" />
        </svg>
    )
}
export default AnchoredTextIcon